import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useVersionCheck } from 'src/hooks/use-version-check';

export function NewVersionBanner() {
  const isOutdated = useVersionCheck();

  return (
    <Dialog
      open={isOutdated}
      onClose={() => {}}
      disableEscapeKeyDown
      sx={{ zIndex: 100000 }}
    >
      <DialogTitle>A new version is available</DialogTitle>
      <DialogContent>
        <DialogContentText>
          All your changes have been saved. Please reload to continue.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => window.location.reload()}>
          Reload
        </Button>
      </DialogActions>
    </Dialog>
  );
}
